import { Button, ListItem, UnorderedList } from "@chakra-ui/react";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaAngleLeft,
  FaAngleRight,
} from "react-icons/fa";
import { PRIMARY, VARIANT } from "../constants/colors";

const Pagination = ({ setCurrentPage, pages, currentPage, pageSize }: any) => {
  const maxItens = 5;
  const maxLeft = (maxItens - 1) / 2;
  const maxFirst = Math.max(pages - (maxItens - 1), 1);
  const first = Math.min(Math.max(currentPage - maxLeft, 1), maxFirst);

  return (
    <>
      <UnorderedList display="flex" style={{ listStyle: "none" }}>
        <ListItem>
          <Button
            onClick={() => setCurrentPage(1)}
            disabled={currentPage == 1}
            variant="link"
            mt="5px"
          >
            <FaAngleDoubleLeft />
          </Button>
        </ListItem>
        <ListItem>
          <Button
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage == 1}
            variant="link"
            mt="5px"
          >
            <FaAngleLeft />
          </Button>
        </ListItem>
        {Array.from({ length: Math.min(maxItens, pages) })
          .map((_, index) => index + first)
          .map((page: any, index: number) => {
            return (
              <ListItem key={index}>
                <Button
                  style={
                    page == currentPage
                      ? { color: VARIANT }
                      : { color: PRIMARY }
                  }
                  value={page}
                  onClick={(e: any) => setCurrentPage(page)}
                  variant="link"
                >
                  {page}
                </Button>
              </ListItem>
            );
          })}
        <ListItem>
          <Button
            onClick={() => setCurrentPage(Number(currentPage) + 1)}
            disabled={currentPage == pages}
            variant="link"
            mt="5px"
          >
            <FaAngleRight />
          </Button>
        </ListItem>
        <ListItem>
          <Button
            onClick={() => setCurrentPage(pages)}
            disabled={currentPage == pages}
            variant="link"
            mt="5px"
          >
            <FaAngleDoubleRight />
          </Button>
        </ListItem>
      </UnorderedList>
    </>
  );
};

export default Pagination;
